import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DrivingHandbook.css";
import "./../typography-home.css";
import handbookImg from "./../../../assets/HomeSection/handbook-img.png";
import bgImage from "./../../../assets/HomeSection/handbook-bg.png";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../../dummyData/HomeDummyData";
import { useSelector } from "react-redux";

function DrivingHandbook() {
  const navigate = useNavigate();
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);

    useEffect(() => {
      switch (selectedLanguage.value) {
        case "english":
          setLanguage(englishData[0]);
          break;
        case "tamil":
          setLanguage(tamilData[0]);
          break;
        default:
          setLanguage(sinhalaData[0]);
          break;
      }

    }, [selectedLanguage]);

  const handleViewPDF = () => {
    navigate("/driving-handbook");
  };

  return (
    <section className="driving-handbook-section pt-5 min-vh-75 d-flex align-items-center">
      <div className="container">
        <h2 className="typography-title text-center fw-bold">
          {language.HandbookTitle}
        </h2>

        <div className="row align-items-center py-2 py-md-5">
          {/* Left Text Section */}
          <div className="col-lg-7 col-md-12">
            <h3 className="fw-semibold text-center text-md-start typography-title-subtitle mb-3">
              {language.HandbookSubTitle}
            </h3>
            <p className="text-muted text-start mb-2 typography-paragraph">
              {language.HandbookSubTitle2}
            </p>
            {/* Image with Overlay */}
            <div
              className="col-lg-12 text-center our-services-section min-vh-90 d-flex align-items-center"
              style={{ backgroundImage: `url(${bgImage})` }}
            >
              <div className="container position-relative ">
                {/* Overlay card */}
                <div className="p-3 p-md-4 rounded-4 my-4 h-100 d-flex flex-column justify-content-between">
                  {/* <h5 className="fw-semibold text-center typography-paragraph-title">
                    {language.HandbookSubTitle}
                  </h5> */}
                  <ul className="list-unstyled m-3 mb-md-4 typography-list-item">
                    <li className="mb-2">• {language.SubTopic1}</li>
                    <li className="mb-2">• {language.SubTopic2}</li>
                    <li className="mb-2">• {language.SubTopic3}</li>
                    <li className="mb-2">• {language.SubTopic4}</li>
                  </ul>
                </div>
                <button
                  className="btn btn-danger px-4 py-2 mb-1 fw-semibold handbook-btn"
                  onClick={handleViewPDF}
                >
                  {language.HandBookBtn}
                </button>
                {/* </div> */}
              </div>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="col-lg-5 col-md-12 py-md-5 py-4 text-center">
            <div className="d-inline-block rounded-4">
              <img
                src={handbookImg}
                alt="drivers guide book sri lanka"
                className="img-fluid rounded-4"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DrivingHandbook;
